const anonymousPlayer = {
  casino: {
    animations: {},
    activeSubcategory: '',
    customCategoriesAssets: []
  },
  modals: {
    login: {
      display: false,
      data: {}
    },
    logout: {
      display: false,
      data: {}
    },
    session: {
      display: false,
      data: {}
    },
    sessionSet: {
      display: false,
      data: {}
    },
    reality: {
      display: false,
      data: {}
    },
    search: {
      display: false,
      data: {}
    },
    popup: {
      display: false,
      data: {}
    },
    messagePopper: {
      display: false,
      data: {}
    },
    lastLogin: {
      display: false,
      data: {}
    },
    providerRegionBlock: {
      display: false
    },
    walletDropdown: {
      display: false,
      data: {}
    },
    claimCenter: {
      display: false,
      data: {
        pending: {
          dailyBonus: null,
          bonusHarvest: null
        },
        expired: {
          dailyBonus: null,
          bonusHarvest: null
        },
        inboxMessageStatusSet: false,
        inboxMessageStatus: {},
        notificationsSet: false
      }
    },
    purchaseLimitKyc: {
      display: false,
      data: {
        reason: ''
      }
    },
    taxIdRequired: {
      display: false
    }
  },
  timers: {},
  forms: {
    step2: {},
    step3: {
      currentDay: '',
      currentMonth: '',
      currentYear: '',
      days: [],
      months: []
    }
  },
  pamTrigger: {}
}

export { anonymousPlayer }
